// Chakra imports
import {Flex,  Center,  Image} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import Footer from "../footer/FooterAuth"

function AuthIllustration(props) {
  const {children, illustrationBackground} = props;
  // Chakra color mode            
  return (
    <Flex flexDir='column' gap='20px' minHeight='100vh'>
      <Flex justifyContent={'center'} flexDir={{'base': 'column', 'md': 'row'}} height='100%' flexGrow={1} gap='40px'>
        <Center>
          <Image src={illustrationBackground} width={{base: "300px", sm: "350px", md: "400px"}}/>
        </Center>
        <Flex alignItems='center' justifyContent={{
          'base':'flex-start',
          'sm': 'center'
        }}>{children}</Flex>
      </Flex>
      <Footer bg='red'/>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
};

export default AuthIllustration;
